import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import Select from "../common/form/select";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";

import { getListaUnidadeConsumidora } from "../cliente/clienteActions";
import { setModoTela } from "./gestorConcessionariaActions";
import { useState } from "react";
import { useEffect } from "react";

function VincularGestorConcessionariaUnidadesForm(props) {
    const [form, setForm] = useState({
        id_tipo_concessionaria: 1,
        id_concessionaria_energia: null,
        id_concessionaria_agua: null,
        id_grupo_faturamento: null,
        unidades_consumidoras: [],
        id_gestor_concessionaria_energia: null,
        id_gestor_concessionaria_agua: null,
    });
    useEffect(() => {
        props.getListaUnidadeConsumidora(form.id_tipo_concessionaria);
    }, [form.id_tipo_concessionaria]);

    const faltaSelecionarConcessionaria = !!(
        (form.id_tipo_concessionaria == 1 && !form.id_concessionaria_energia) ||
        (form.id_tipo_concessionaria == 2 && !form.id_concessionaria_agua)
    );
    const readOnly = !props.usuarioLogado.acesso_gestor_concessionaria_vincular;
    const CONCESSIONARIA_ENERGIA = form.id_tipo_concessionaria == 1;
    // const CONCESSIONARIA_AGUA = form.id_tipo_concessionaria == 2;

    const ucsSelect = props.listaUnidadeConsumidora.filter((uc) => {
        const validacaoCliente = !form.id_cliente || uc.id_cliente == form.id_cliente;
        const validacaoGrupoFaturamento = !form.id_grupo_faturamento || uc.id_grupo_faturamento == form.id_grupo_faturamento;
        const validacaoConcessionariaEnergia = !form.id_concessionaria_energia || uc.id_concessionaria == form.id_concessionaria_energia;
        const validacaoConcessionariaAgua = !form.id_concessionaria_agua || uc.id_concessionaria_agua == form.id_concessionaria_agua;
        return validacaoCliente && validacaoGrupoFaturamento && validacaoConcessionariaEnergia && validacaoConcessionariaAgua;
    });

    const unidades = ucsSelect.filter(
        (uc) => !faltaSelecionarConcessionaria && (!form.unidades_consumidoras.length || form.unidades_consumidoras.find((ucFiltro) => ucFiltro.value == uc.id))
    );

    const listaSelectClientes = props.listaCliente.filter((cli) => {
        //ou é energia, que todas uc são, ou se for agua, tem que ter uc de agua
        const validacaoTipo = form.id_tipo_concessionaria == 1 || (form.id_tipo_concessionaria == 2 && cli.itens.find((uc) => uc.unidades_consumidoras_agua.length));

        const validacaoGrupoFaturamento = !form.id_grupo_faturamento || cli.itens.find((uc) => uc.id_grupo_faturamento == form.id_grupo_faturamento);
        const validacaoConcessionariaEnergia = !form.id_concessionaria_energia || cli.itens.find((uc) => uc.id_concessionaria == form.id_concessionaria_energia);
        const validacaoConcessionariaAgua = !form.id_concessionaria_agua || cli.itens.find((uc) => uc.unidades_consumidoras_agua.length);
        return validacaoGrupoFaturamento && validacaoConcessionariaEnergia && validacaoConcessionariaAgua && validacaoTipo;
    });

    return (
        <>
            <ContentCard>
                <Form>
                    <Row alignCenter>
                        <Grid cols="12 12 8 8">
                            <ContentCardBody>
                                <Row>
                                    <h6 style={{ margin: "20px 8px" }}>
                                        Filtre apenas as unidades que você deseja vincular um gestor, ou remover o vinculo existente (deixando o gestor vazio)
                                    </h6>
                                </Row>
                                <Row>
                                    <Select
                                        cols={CONCESSIONARIA_ENERGIA ? "12 12 4 4" : "12 12 6 6"}
                                        name="id_tipo_concessionaria"
                                        options={props.listaTipoConcessionaria}
                                        label="Tipo de Concessionária"
                                        isClearable={false}
                                        isSearchable={true}
                                        placeholder="Selecione o tipo de concessionária"
                                        value={form.id_tipo_concessionaria}
                                        onChange={(value) => {
                                            setForm({
                                                ...form,
                                                id_tipo_concessionaria: value,
                                                id_concessionaria_energia: null,
                                                id_concessionaria_agua: null,
                                                id_grupo_faturamento: null,
                                                id_cliente: listaSelectClientes.find((cli) => cli.id == form.id_cliente) ? form.id_cliente : null,
                                                unidades_consumidoras: [],
                                                id_gestor_concessionaria_energia: null,
                                                id_gestor_concessionaria_agua: null,
                                            });
                                        }}
                                        readOnly={readOnly}
                                    />
                                    <Select
                                        cols={CONCESSIONARIA_ENERGIA ? "12 12 4 4" : "12 12 6 6"}
                                        name={CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"}
                                        options={props[CONCESSIONARIA_ENERGIA ? "listaConcessionariaEnergiaSelect" : "listaConcessionariaAguaSelect"]}
                                        label="Concessionária"
                                        placeholder="Selecione a Concessionária"
                                        value={form[CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"]}
                                        onChange={(value) => {
                                            setForm({
                                                ...form,
                                                [CONCESSIONARIA_ENERGIA ? "id_concessionaria_energia" : "id_concessionaria_agua"]: value,
                                                [CONCESSIONARIA_ENERGIA ? "id_concessionaria_agua" : "id_concessionaria_energia"]: null, //salva null no inverso
                                                id_gestor_concessionaria_energia: null,
                                                id_gestor_concessionaria_agua: null,
                                            });
                                        }}
                                        readOnly={readOnly}
                                    />

                                    {CONCESSIONARIA_ENERGIA ? (
                                        <Select
                                            readOnly={readOnly || faltaSelecionarConcessionaria}
                                            name="id_grupo_faturamento"
                                            options={props.listaGrupoFaturamento}
                                            label="Tipo de Faturamento"
                                            cols="12 12 4 4"
                                            placeholder="Selecione o tipo de faturamento"
                                            value={form.id_grupo_faturamento}
                                            onChange={(value) => {
                                                setForm({
                                                    ...form,
                                                    id_grupo_faturamento: value,
                                                });
                                            }}
                                        />
                                    ) : null}
                                </Row>
                                <Row>
                                    <Select
                                        readOnly={readOnly || faltaSelecionarConcessionaria}
                                        name="id_cliente"
                                        options={listaSelectClientes}
                                        label="Cliente"
                                        cols={"12 12 6 6"}
                                        placeholder="Selecione o Cliente"
                                        value={form.id_cliente}
                                        onChange={(value) => {
                                            setForm({
                                                ...form,
                                                id_cliente: value,
                                                unidades_consumidoras: [],
                                            });
                                        }}
                                    />
                                    <Select
                                        readOnly={readOnly || faltaSelecionarConcessionaria}
                                        options={ucsSelect}
                                        label="Unidades Consumidoras"
                                        cols="12 12 6 6"
                                        placeholder="Selecione as UCs"
                                        isMulti={true}
                                        value={form.unidades_consumidoras}
                                        onChange={(ucsSelecionadas) => {
                                            setForm({
                                                ...form,
                                                unidades_consumidoras: [...ucsSelecionadas],
                                            });
                                        }}
                                    />
                                </Row>
                                <Row>
                                    <h6 style={{ padding: 10 }}>
                                        Unidades em que o gestor da concessionária selecionado será vinculado (confira as unidades listadas na tabela antes de salvar o vínculo)
                                    </h6>
                                </Row>
                                <Row alignCenter style={{ padding: 10 }}>
                                    <div style={{ backgroundColor: "#EEE", padding: 10, width: "100%", marginBottom: 10 }}>
                                        <Table responsive maxHeight={250}>
                                            <THead>
                                                <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                                    <Th sticky>Tipo</Th>
                                                    <Th sticky>Concessionária</Th>
                                                    <Th sticky>Cliente</Th>
                                                    <Th sticky>Unidade Consumidora</Th>
                                                    <Th sticky>Grupo Faturamento</Th>
                                                    <Th sticky>Gestor Atual</Th>
                                                </NewTr>
                                            </THead>
                                            <TBody>
                                                {unidades.map((item) => {
                                                    const tipoConcessionaria = props.listaTipoConcessionaria.find((tc) => tc.id == form.id_tipo_concessionaria);
                                                    const cliente = props.listaCliente.find((cli) => cli.id == item.id_cliente);
                                                    const grupoFaturamento = props.listaGrupoFaturamento.find((gf) => gf.id == item.id_grupo_faturamento);
                                                    const gestorAtual = CONCESSIONARIA_ENERGIA
                                                        ? props.listaGestorConcessionariaSelect.find((gc) => gc.id == item.id_gestor_concessionaria_energia)
                                                        : props.listaGestorConcessionariaSelect.find((gc) => gc.id == item.id_gestor_concessionaria_agua);
                                                    const concessionaria = props[
                                                        CONCESSIONARIA_ENERGIA ? "listaConcessionariaEnergiaSelect" : "listaConcessionariaAguaSelect"
                                                    ].find((c) => c.id == item[CONCESSIONARIA_ENERGIA ? "id_concessionaria" : "id_concessionaria_agua"]);

                                                    if (!concessionaria) return null;
                                                    return (
                                                        <NewTr key={item.id} backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"} botoes={[]}>
                                                            <Td minWidth={150}>{tipoConcessionaria.valor}</Td>
                                                            <Td minWidth={150} paddingRight={10}>
                                                                {concessionaria.valor}
                                                            </Td>
                                                            <Td>{cliente.valor}</Td>
                                                            <Td paddingRight={10}>{item.valor}</Td>
                                                            <Td maxWidth={230}>{CONCESSIONARIA_ENERGIA ? grupoFaturamento.valor : " - "}</Td>
                                                            <Td paddingRight={10}>{gestorAtual ? gestorAtual.valor : " - "}</Td>
                                                        </NewTr>
                                                    );
                                                })}
                                            </TBody>
                                        </Table>
                                    </div>
                                </Row>
                                <Row>
                                    <span style={{ color: "#ee1754", margin: "20px 8px" }}>
                                        Obs: Se nenhum gestor for selecionado e você clicar em salvar, o gestor será removido de todas as unidades exibidas na tabela.
                                    </span>
                                </Row>
                                <Row>
                                    <Select
                                        readOnly={readOnly || faltaSelecionarConcessionaria}
                                        name={CONCESSIONARIA_ENERGIA ? "id_gestor_concessionaria_energia" : "id_gestor_concessionaria_agua"}
                                        options={props.listaGestorConcessionariaSelect.filter(
                                            (gc) =>
                                                (!form.id_concessionaria_energia || gc.id_concessionaria_energia == form.id_concessionaria_energia) &&
                                                (!form.id_concessionaria_agua || gc.id_concessionaria_agua == form.id_concessionaria_agua) &&
                                                (!form.id_tipo_concessionaria || gc.id_tipo_concessionaria == form.id_tipo_concessionaria)
                                        )}
                                        label="Gestor da Concessionária"
                                        cols="12 12 12 12"
                                        placeholder="Selecione o gestor que será vinculado às unidades"
                                        value={form[CONCESSIONARIA_ENERGIA ? "id_gestor_concessionaria_energia" : "id_gestor_concessionaria_agua"]}
                                        onChange={(value) => {
                                            setForm({
                                                ...form,
                                                [CONCESSIONARIA_ENERGIA ? "id_gestor_concessionaria_energia" : "id_gestor_concessionaria_agua"]: value,
                                                [CONCESSIONARIA_ENERGIA ? "id_gestor_concessionaria_agua" : "id_gestor_concessionaria_energia"]: null,
                                            });
                                        }}
                                    />
                                </Row>
                            </ContentCardBody>
                        </Grid>
                    </Row>

                    <ContentCardFooter>
                        <Row alignCenter>
                            <Grid cols="6 6 4 3">
                                <Button
                                    text={"Salvar"}
                                    type={"success"}
                                    icon={"fa fa-check"}
                                    disabled={readOnly || faltaSelecionarConcessionaria}
                                    event={() => {
                                        props.vincularGestorConcessionariaNasUnidades({
                                            registro: {
                                                ...form,
                                                ids_unidades_vinculadas: unidades.map((uc) => uc.id),
                                            },
                                            callback: () => props.getListaUnidadeConsumidora(form.id_tipo_concessionaria),
                                        });
                                    }}
                                />
                            </Grid>
                            <Grid cols="6 6 4 3">
                                <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setModoTela("lista")} />
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                </Form>
            </ContentCard>
        </>
    );
}

const mapStateToProps = (state) => ({
    usuarioLogado: state.auth.usuarioLogado,
    aguardando: state.gestorConcessionaria.aguardando,
    listaGestorConcessionariaSelect: state.gestorConcessionaria.listaGestorConcessionariaSelect,
    listaConcessionariaEnergiaSelect: state.concessionaria.listaConcessionariaEnergiaSelect,
    listaConcessionariaAguaSelect: state.concessionaria.listaConcessionariaAguaSelect,
    listaTipoConcessionaria: state.concessionaria.listaTipoConcessionaria,
    listaCliente: state.cliente.listaSelect,
    listaUnidadeConsumidora: state.cliente.listaUnidadeConsumidora,
    listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({ setModoTela, getListaUnidadeConsumidora }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VincularGestorConcessionariaUnidadesForm);
